import { render, staticRenderFns } from "./hover-message.vue?vue&type=template&id=4aca970e&"
import script from "./hover-message.vue?vue&type=script&lang=js&"
export * from "./hover-message.vue?vue&type=script&lang=js&"
import style0 from "./hover-message.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports